import { environment } from '@env/environment';
import { InjectableRxStompConfig } from '@stomp/ng2-stompjs';
import * as R from 'ramda';

const getPathName = () => {
  const pathName = window.location.pathname;
  return R.slice(0, pathName.length - 1, pathName);
};

const prepareConnectingUrl = () => {
  // the absolute URL is needed to establish the web socket connection
  // replace the protocol in production mode
  const baseUrl = !environment.production
    ? environment.webSocketBaseUrl
    : `wss://${environment.webSocketBaseUrl}${getPathName()}`;
  return `${baseUrl}/socket`;
};

export const pcsRxStompConfig: InjectableRxStompConfig = {
  // Which server?
  brokerURL: prepareConnectingUrl(),

  // How often to heartbeat?
  // Interval in milliseconds, set to 0 to disable
  heartbeatIncoming: 0, // Typical value 0 - disabled
  heartbeatOutgoing: 20000, // Typical value 20000 - every 20 seconds

  // Wait in milliseconds before attempting auto reconnect
  // Set to 0 to disable
  // Typical value 500 (500 milli seconds)
  reconnectDelay: 1000
};
